// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"52523108","488":"b6dc6404","977":"1267f232"}[chunkId] + ".chunk.js";
};